import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { REPLACEMENT_ERROR, runTemplateForHtml, runTemplateForUrl } from '../engagement-templates';
export function rebuildButtonAction(replacedUrl, action) {
  return _objectSpread(_objectSpread({}, action), {}, {
    data: action.data && _objectSpread(_objectSpread({}, action.data), {}, {
      url: replacedUrl
    })
  });
}
export function runTemplateOnInputs(variables, messageInputs) {
  var keys = Object.keys(messageInputs);
  var output = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var input = messageInputs[key];
    if (input) {
      var isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
      var replacedInput = isUrl ? runTemplateForUrl(input, variables) : runTemplateForHtml(input, variables);
      if (replacedInput.type === REPLACEMENT_ERROR) {
        return null;
      }
      output[key] = replacedInput.result;
    }
  }
  return output;
}